import { Directive, Inject, Injectable, OnInit } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
//import { default as _rollupMoment } from 'moment';

export const DATE_FORMAT_EU = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'DD/MM/YYYY',
  },
};

export const DATE_FORMAT_AM = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'MM/DD/YYYY',
    monthYearA11yLabel: 'MM/DD/YYYY',
  },
};

export const UPDATED_FORMAT = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MMM DD, YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'MMMM DD, YYYY',
    monthYearA11yLabel: 'MMMM DD, YYYY',
  },
};

@Injectable({
  providedIn: 'root',
})
export class DifferentDateFormatPicker {
  public format: 'short' | 'long';

  public dateInput: 'MM/DD/YYYY' | 'DD/MM/YYYY';

  public setFormat(format) {
    this.format = format;
  }

  public setParse(format) {
    this.dateInput = format;
  }

  get parse() {
    return {
      dateInput: this.dateInput,
    };
  }
  get display() {
    return {
      dateInput: this.format === 'short' ? 'MMM DD, YYYY' : 'MMMM DD, YYYY',
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'MMMM DD, YYYY',
      monthYearA11yLabel: 'MMMM DD, YYYY',
    };
  }
}

@Directive({
  selector: '[newDateFormat]',
  providers: [{ provide: MAT_DATE_FORMATS, useClass: DifferentDateFormatPicker }],
})
export class NewDateFormat {}

@Directive({
  selector: '[euDateFormat]',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT_EU }],
})
export class EuDateFormat {}

@Directive({
  selector: '[amDateFormat]',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT_AM }],
})
export class AmDateFormat {}
